import { Divider } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { Header } from '@app/sections/header';
import { Strings } from '@app/constants';
import { useTable } from '@app/components/table';
import LeaveManagementList from './leave-management-list';
import { useDialog, useRequestState, useSearch } from '@app/hooks';
import { AddLeaveDays } from './add-leave-days';
import { getLeaveManagement } from '../slice';
import { selectLeaveManagementState } from '../selectors';
import { useAuthRolePermissions } from '@app/utils';

const LeaveManagementPage = () => {
  const tableProps = useTable();
  const leaveSettingDialog = useDialog();
  const dispatch = useDispatch();
  const { hasPermission } = useAuthRolePermissions();
  const canAddLeaveSetting = hasPermission('LeaveSetting', 'w');

  useEffect(() => {
    dispatch(getLeaveManagement());
  }, [dispatch]);

  const { data, loading } = useRequestState({
    stateSelector: selectLeaveManagementState,
    errorShown: true,
  });

  const searchProps = useSearch({
    data,
    fields: ['leaveType', 'allowedDays', 'id'],
  });

  return (
    <>
      <Header
        title={Strings.sidebar.leaveManagement}
        helperText={''}
        actionButtonTitle={canAddLeaveSetting ? Strings.button.addLeaveDays : undefined}
        onClickActionButton={leaveSettingDialog.show}
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: searchProps.handleSearchChange,
        }}
      />
      <Divider />
      <LeaveManagementList
        tableProps={tableProps}
        rows={searchProps.filteredRows}
        loading={loading}
      />
      {leaveSettingDialog.visible && <AddLeaveDays open onClose={leaveSettingDialog.hide} />}
    </>
  );
};

export { LeaveManagementPage };
